import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelRadio as _vModelRadio, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/remove-circled.svg'
import _imports_1 from '../../assets/b2cOfficialImgExample.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-0f6d3ce5")

_pushScopeId("data-v-0f6d3ce5")
const _hoisted_1 = {
  class: "container popup-container",
  id: "price-list"
}
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "row edit-row" }
const _hoisted_4 = { class: "page-header-title mx-auto" }
const _hoisted_5 = { class: "row edit-row" }
const _hoisted_6 = { class: "card col-12 px-0" }
const _hoisted_7 = {
  class: "card-header",
  id: "headingProductPricing"
}
const _hoisted_8 = { class: "mb-0" }
const _hoisted_9 = {
  key: 0,
  class: "btn btn-link collapsed",
  type: "button"
}
const _hoisted_10 = {
  key: 1,
  class: "btn btn-link collapsed",
  type: "button"
}
const _hoisted_11 = {
  id: "productPricing",
  class: "collapse show",
  "aria-labelledby": "headingProductPricing",
  "data-parent": "#accordionExample"
}
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = {
  key: 0,
  class: "position-relative"
}
const _hoisted_14 = { class: "several-section" }
const _hoisted_15 = { class: "watch-the-video p-0" }
const _hoisted_16 = {
  target: "_blank",
  href: "https://youtu.be/4YztZUiY-78"
}
const _hoisted_17 = { class: "form-text small-text" }
const _hoisted_18 = {
  key: 1,
  class: "position-relative"
}
const _hoisted_19 = { class: "several-section" }
const _hoisted_20 = { class: "edit-mode" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-12 col-lg-6" }
const _hoisted_23 = { class: "product-title" }
const _hoisted_24 = { class: "text-area-length" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("/30")
const _hoisted_26 = {
  key: 0,
  class: "col-12 col-lg-6 delete-price-list order-first order-lg-last",
  style: {"padding":"0","padding-inline-end":"15px"}
}
const _hoisted_27 = { class: "toggle-text" }
const _hoisted_28 = { style: {"top":"initial","height":"29px"} }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-12 col-lg-6" }
const _hoisted_31 = { class: "product-title" }
const _hoisted_32 = /*#__PURE__*/_createVNode("i", { class: "caret-custom-icon" }, null, -1)
const _hoisted_33 = { class: "col-12 col-lg-6" }
const _hoisted_34 = { class: "product-title" }
const _hoisted_35 = /*#__PURE__*/_createVNode("i", { class: "caret-custom-icon" }, null, -1)
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col-12 col-lg-6" }
const _hoisted_38 = { class: "product-title" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "col-6" }
const _hoisted_41 = /*#__PURE__*/_createVNode("i", { class: "caret-custom-icon" }, null, -1)
const _hoisted_42 = { class: "col-12 col-lg-6" }
const _hoisted_43 = { class: "product-title" }
const _hoisted_44 = {
  key: 0,
  class: "row"
}
const _hoisted_45 = { class: "col-12" }
const _hoisted_46 = { class: "product-title" }
const _hoisted_47 = {
  class: "row",
  style: {"margin-bottom":"0"}
}
const _hoisted_48 = { class: "col-12" }
const _hoisted_49 = {
  class: "cbx2",
  for: "isPriceAutomatic",
  tabindex: "12"
}
const _hoisted_50 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("circle", {
      class: "radio-circle",
      cx: "6",
      cy: "5",
      r: "2",
      fill: "white",
      stroke: "white",
      "stroke-width": "2"
    })
  ])
], -1)
const _hoisted_51 = { class: "checkboxtext" }
const _hoisted_52 = { class: "col-12" }
const _hoisted_53 = {
  class: "cbx2",
  for: "isPriceAutomatic2",
  tabindex: "12"
}
const _hoisted_54 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("circle", {
      class: "radio-circle",
      cx: "6",
      cy: "5",
      r: "2",
      fill: "white",
      stroke: "white",
      "stroke-width": "2"
    })
  ])
], -1)
const _hoisted_55 = { class: "checkboxtext" }
const _hoisted_56 = { class: "row" }
const _hoisted_57 = { class: "col-12 col-lg-6" }
const _hoisted_58 = { class: "product-title" }
const _hoisted_59 = /*#__PURE__*/_createVNode("i", { class: "caret-custom-icon" }, null, -1)
const _hoisted_60 = { class: "col-12 col-lg-6" }
const _hoisted_61 = { class: "product-title" }
const _hoisted_62 = /*#__PURE__*/_createVNode("i", { class: "caret-custom-icon" }, null, -1)
const _hoisted_63 = { class: "row" }
const _hoisted_64 = { class: "col-12 col-lg-6" }
const _hoisted_65 = { class: "product-title" }
const _hoisted_66 = { class: "row" }
const _hoisted_67 = { class: "col-12" }
const _hoisted_68 = /*#__PURE__*/_createVNode("i", { class: "caret-custom-icon" }, null, -1)
const _hoisted_69 = {
  key: 1,
  class: "row"
}
const _hoisted_70 = { class: "col-12" }
const _hoisted_71 = { class: "product-title" }
const _hoisted_72 = { class: "text-area-length" }
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" /255")
const _hoisted_74 = {
  key: 2,
  class: "row"
}
const _hoisted_75 = { class: "col-12" }
const _hoisted_76 = { class: "product-title" }
const _hoisted_77 = { class: "text-area-length" }
const _hoisted_78 = /*#__PURE__*/_createTextVNode(" /1000")
const _hoisted_79 = { class: "several-section" }
const _hoisted_80 = { class: "edit-mode" }
const _hoisted_81 = { class: "row" }
const _hoisted_82 = { class: "col-12" }
const _hoisted_83 = {
  key: 0,
  class: "row"
}
const _hoisted_84 = { class: "col-3 col-lg-3 custom-type-column" }
const _hoisted_85 = {
  key: 0,
  class: "customer-type-header"
}
const _hoisted_86 = {
  key: 1,
  class: "customer-type-header"
}
const _hoisted_87 = {
  key: 2,
  class: "customer-type-header"
}
const _hoisted_88 = { class: "col-3 col-lg-2 price-column customer-type-header" }
const _hoisted_89 = { class: "col-3 col-lg-2 price-column customer-type-header" }
const _hoisted_90 = { class: "col-2 price-column" }
const _hoisted_91 = {
  key: 0,
  class: "customer-type-header"
}
const _hoisted_92 = {
  key: 1,
  class: "customer-type-header"
}
const _hoisted_93 = { class: "col-2" }
const _hoisted_94 = { class: "customer-type-header" }
const _hoisted_95 = {
  class: "col-3 col-lg-3 custom-type-column",
  style: {"position":"relative"}
}
const _hoisted_96 = {
  key: 0,
  class: "multy-invalid-feedback"
}
const _hoisted_97 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_98 = { key: 0 }
const _hoisted_99 = { key: 1 }
const _hoisted_100 = { class: "col-3 col-lg-2 price-column" }
const _hoisted_101 = { class: "col-3 col-lg-2 price-column" }
const _hoisted_102 = {
  class: "col-2 price-column",
  style: {"position":"relative"}
}
const _hoisted_103 = {
  key: 0,
  class: "multy-invalid-feedback"
}
const _hoisted_104 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_105 = {
  class: "col-2 col-lg-2 price-column",
  style: {"position":"relative"}
}
const _hoisted_106 = { class: "col-2 col-lg-1 my-auto text-r" }
const _hoisted_107 = /*#__PURE__*/_createVNode("img", {
  style: {"cursor":"pointer"},
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_108 = { class: "row new-price-list-section" }
const _hoisted_109 = {
  key: 0,
  class: "col-12"
}
const _hoisted_110 = {
  class: "btn browse-photo green-button",
  type: "submit"
}
const _hoisted_111 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-plus-circle fs-26 browse-icon" }, null, -1)
const _hoisted_112 = {
  key: 1,
  class: "col-lg-6 col-12 set-b2c-price"
}
const _hoisted_113 = {
  class: "modal fade",
  id: "setb2cPrice",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalCenterTitle",
  "aria-hidden": "true"
}
const _hoisted_114 = {
  class: "modal-dialog modal-dialog-centered  modal-lg",
  role: "document"
}
const _hoisted_115 = { class: "modal-content" }
const _hoisted_116 = { class: "modal-header" }
const _hoisted_117 = {
  class: "modal-title",
  id: "exampleModalLongTitle"
}
const _hoisted_118 = {
  class: "modal-title",
  id: "exampleModalLongTitle"
}
const _hoisted_119 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  id: "close-modal",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_120 = { class: "modal-body" }
const _hoisted_121 = { class: "row content-text" }
const _hoisted_122 = { class: "col-lg-8 col-12 price-modal-main-content" }
const _hoisted_123 = {
  class: "row graytext",
  style: {"margin-bottom":"20px"}
}
const _hoisted_124 = { class: "col-4" }
const _hoisted_125 = { class: "col-4" }
const _hoisted_126 = {
  key: 0,
  class: "col-3"
}
const _hoisted_127 = {
  key: 1,
  class: "col-3"
}
const _hoisted_128 = { class: "col-4 ellipsis-preview" }
const _hoisted_129 = { class: "col-4 ellipsis-preview" }
const _hoisted_130 = {
  key: 0,
  class: "col-3"
}
const _hoisted_131 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("circle", {
      class: "radio-circle",
      cx: "6",
      cy: "5",
      r: "2",
      fill: "white",
      stroke: "white",
      "stroke-width": "2"
    })
  ])
], -1)
const _hoisted_132 = {
  key: 1,
  class: "col-3"
}
const _hoisted_133 = { class: "col-lg-4 col-12 left-border" }
const _hoisted_134 = { class: "graytext" }
const _hoisted_135 = { class: "preview-content" }
const _hoisted_136 = {
  key: 0,
  class: "preview-image-content"
}
const _hoisted_137 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_138 = {
  key: 1,
  class: "preview-text-content"
}
const _hoisted_139 = {
  class: "preview-title",
  style: {"font-weight":"bold"}
}
const _hoisted_140 = {
  key: 0,
  class: "preview-text"
}
const _hoisted_141 = {
  class: "preview-text graytext",
  style: {"margin-inline-end":"22px"}
}
const _hoisted_142 = { class: "preview-title" }
const _hoisted_143 = {
  key: 2,
  class: "preview-image-content2",
  style: {"direction":"rtl"}
}
const _hoisted_144 = { class: "preview2-title" }
const _hoisted_145 = /*#__PURE__*/_createVNode("svg", {
  class: "price-tag",
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("g", null, [
    /*#__PURE__*/_createVNode("path", {
      fill: "none",
      d: "M0 0h24v24H0z"
    }),
    /*#__PURE__*/_createVNode("path", { d: "M10.9 2.1l9.899 1.415 1.414 9.9-9.192 9.192a1 1 0 0 1-1.414 0l-9.9-9.9a1 1 0 0 1 0-1.414L10.9 2.1zm2.828 8.486a2 2 0 1 0 2.828-2.829 2 2 0 0 0-2.828 2.829z" })
  ])
], -1)
const _hoisted_146 = {
  class: "col-8 customer-name",
  style: {"padding-inline-start":"0"}
}
const _hoisted_147 = /*#__PURE__*/_createVNode("span", {
  class: "small-red-dot",
  style: {"display":"inline-block"}
}, null, -1)
const _hoisted_148 = {
  class: "col-4",
  style: {"padding":"0","text-align":"left"}
}
const _hoisted_149 = { class: "price" }
const _hoisted_150 = { class: "modal-footer" }
const _hoisted_151 = { class: "product-edit-container" }
const _hoisted_152 = { class: "row col-10 col-lg-6 mx-auto" }
const _hoisted_153 = { class: "col-6 order-modify-container" }
const _hoisted_154 = { class: "col-6 order-modify-container" }
const _hoisted_155 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-save fs-20" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_Calendar = _resolveComponent("Calendar")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("h1", _hoisted_4, _toDisplayString($setup.product.name), 1)
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("h5", _hoisted_8, [
              ($setup.prodPriceId == 0)
                ? (_openBlock(), _createBlock("button", _hoisted_9, _toDisplayString(_ctx.$t('priceList.newProductPriceList')), 1))
                : (_openBlock(), _createBlock("button", _hoisted_10, _toDisplayString(_ctx.$t('priceList.editProductPriceList')), 1))
            ])
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, [
              ($setup.showInfo)
                ? (_openBlock(), _createBlock("div", _hoisted_13, [
                    _createVNode("div", _hoisted_14, [
                      _createVNode("div", _hoisted_15, [
                        _createVNode("a", _hoisted_16, _toDisplayString(_ctx.$t('help.watchTheVideo')), 1)
                      ]),
                      _createVNode("small", _hoisted_17, _toDisplayString(_ctx.$t('help.aboutProductPricing')), 1),
                      _createVNode("i", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.showInfo = !$setup.showInfo)),
                        class: "icon-f icon-arrow-back fs-28"
                      })
                    ])
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_18, [
                    _createVNode("i", {
                      class: "icon-f icon-info info-icon fs-20",
                      style: {"z-index":"2"},
                      onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.showInfo = !$setup.showInfo))
                    }),
                    _createVNode("div", _hoisted_19, [
                      _createVNode("div", _hoisted_20, [
                        _createVNode("div", _hoisted_21, [
                          _createVNode("div", _hoisted_22, [
                            _createVNode("p", _hoisted_23, _toDisplayString(_ctx.$t('product.priceList.name')), 1),
                            _withDirectives(_createVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ($setup.currentPricing.title = $event)),
                              class: ["form-control h-auto bookit-input", $setup.validated && !$setup.currentPricing.title ? 'incorrect-text' : ''],
                              maxlength: "30",
                              onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.checkTitleLength && $setup.checkTitleLength(...args)))
                            }, null, 34), [
                              [_vModelText, $setup.currentPricing.title]
                            ]),
                            _createVNode("span", _hoisted_24, [
                              _createVNode("span", {
                                class: { 'length-limit': $setup.currentPricing.title.length > 29 }
                              }, _toDisplayString($setup.currentPricing.title.length), 3),
                              _hoisted_25
                            ])
                          ]),
                          ($setup.currentPricing.id !== '')
                            ? (_openBlock(), _createBlock("div", _hoisted_26, [
                                _createVNode("span", _hoisted_27, _toDisplayString(_ctx.$t('product.active')), 1),
                                _createVNode("span", _hoisted_28, [
                                  _createVNode("input", {
                                    type: "checkbox",
                                    class: "toggle",
                                    checked: $setup.currentPricing.deletedAt === null,
                                    onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => ($setup.activateOrDisactivate && $setup.activateOrDisactivate(...args)), ["stop"]))
                                  }, null, 8, ["checked"])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("div", _hoisted_29, [
                          _createVNode("div", _hoisted_30, [
                            _createVNode("p", _hoisted_31, _toDisplayString(_ctx.$t('priceList.whichPriceTypeSeePrice')), 1),
                            _createVNode(_component_Multiselect, {
                              options: $setup.priceTypes,
                              modelValue: $setup.currentPricing.priceTypeId,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ($setup.currentPricing.priceTypeId = $event)),
                              label: "text",
                              valueProp: "id",
                              searchable: true,
                              id: "priceType-select",
                              canDeselect: false,
                              closeOnSelect: true,
                              class: [$setup.validated && !$setup.currentPricing.priceTypeId ? 'incorrect-text' : '', "custom-multiselect-input"]
                            }, {
                              caret: _withId(() => [
                                _hoisted_32
                              ]),
                              _: 1
                            }, 8, ["options", "modelValue", "class"])
                          ]),
                          _createVNode("div", _hoisted_33, [
                            _createVNode("p", _hoisted_34, _toDisplayString(_ctx.$t('priceList.channel')), 1),
                            _createVNode(_component_Multiselect, {
                              options: $setup.channels,
                              modelValue: $setup.currentPricing.channelId,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ($setup.currentPricing.channelId = $event)),
                              label: "text",
                              valueProp: "id",
                              searchable: true,
                              id: "priceType-select",
                              canDeselect: false,
                              closeOnSelect: true,
                              class: "custom-multiselect-input"
                            }, {
                              caret: _withId(() => [
                                _hoisted_35
                              ]),
                              _: 1
                            }, 8, ["options", "modelValue"])
                          ])
                        ]),
                        _createVNode("div", _hoisted_36, [
                          _createVNode("div", _hoisted_37, [
                            _createVNode("p", _hoisted_38, _toDisplayString(_ctx.$t('priceList.currency')), 1),
                            _createVNode("div", _hoisted_39, [
                              _createVNode("div", _hoisted_40, [
                                _createVNode(_component_Multiselect, {
                                  label: "symbol",
                                  valueProp: "id",
                                  options: $setup.currencies,
                                  modelValue: $setup.currentPricing.currencyId,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ($setup.currentPricing.currencyId = $event)),
                                  searchable: true,
                                  id: "currency-select",
                                  canDeselect: false,
                                  closeOnSelect: true,
                                  class: [$setup.validated && !$setup.currentPricing.currencyId ? 'incorrect-field' : '', "custom-multiselect-input currency"]
                                }, {
                                  caret: _withId(() => [
                                    _hoisted_41
                                  ]),
                                  _: 1
                                }, 8, ["options", "modelValue", "class"])
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_42, [
                            _createVNode("p", _hoisted_43, _toDisplayString(_ctx.$t('priceList.thePriceValidFrom')), 1),
                            _createVNode(_component_Calendar, {
                              ref: "calendar",
                              minDate: new Date(),
                              onDateSelect: $setup.dateChanged,
                              modelValue: $setup.dateRange.fromDate,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ($setup.dateRange.fromDate = $event)),
                              selectionMode: "single",
                              dateFormat: "dd/mm/yy"
                            }, null, 8, ["minDate", "onDateSelect", "modelValue"]),
                            _createVNode(_component_Calendar, {
                              ref: "calendar",
                              onDateSelect: $setup.dateChanged,
                              modelValue: $setup.dateRange.toDate,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ($setup.dateRange.toDate = $event)),
                              minDate: $setup.dateRange.fromDate,
                              selectionMode: "single",
                              dateFormat: "dd/mm/yy"
                            }, null, 8, ["onDateSelect", "modelValue", "minDate"])
                          ])
                        ]),
                        ($setup.product.canChangeOrderConfirmation)
                          ? (_openBlock(), _createBlock("div", _hoisted_44, [
                              _createVNode("div", _hoisted_45, [
                                _createVNode("p", _hoisted_46, _toDisplayString(_ctx.$t('priceList.isPriceAutomatic')), 1),
                                _createVNode("div", _hoisted_47, [
                                  _createVNode("div", _hoisted_48, [
                                    _withDirectives(_createVNode("input", {
                                      class: "inp-cbx2",
                                      name: "isPriceAutomatic",
                                      value: true,
                                      type: "radio",
                                      style: {"display":"none"},
                                      id: "isPriceAutomatic",
                                      checked: $setup.currentPricing.autoConfirm === true,
                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ($setup.currentPricing.autoConfirm = $event))
                                    }, null, 8, ["checked"]), [
                                      [_vModelRadio, $setup.currentPricing.autoConfirm]
                                    ]),
                                    _createVNode("label", _hoisted_49, [
                                      _hoisted_50,
                                      _createVNode("span", _hoisted_51, _toDisplayString(_ctx.$t('priceList.autoConfirm')), 1)
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_52, [
                                    _withDirectives(_createVNode("input", {
                                      class: "inp-cbx2",
                                      name: "isPriceAutomatic",
                                      value: false,
                                      type: "radio",
                                      style: {"display":"none"},
                                      id: "isPriceAutomatic2",
                                      checked: $setup.currentPricing.autoConfirm === false,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ($setup.currentPricing.autoConfirm = $event))
                                    }, null, 8, ["checked"]), [
                                      [_vModelRadio, $setup.currentPricing.autoConfirm]
                                    ]),
                                    _createVNode("label", _hoisted_53, [
                                      _hoisted_54,
                                      _createVNode("span", _hoisted_55, _toDisplayString(_ctx.$t('priceList.onRequest')), 1)
                                    ])
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode("div", _hoisted_56, [
                          _createVNode("div", _hoisted_57, [
                            _createVNode("p", _hoisted_58, _toDisplayString(_ctx.$t('coupon.clubName')), 1),
                            _createVNode(_component_Multiselect, {
                              label: "name",
                              valueProp: "id",
                              options: $setup.businessClients,
                              modelValue: $setup.currentPricing.businessClientId,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ($setup.currentPricing.businessClientId = $event)),
                              searchable: true,
                              id: "currency-select",
                              canDeselect: true,
                              closeOnSelect: true,
                              class: "custom-multiselect-input currency"
                            }, {
                              caret: _withId(() => [
                                _hoisted_59
                              ]),
                              clear: _withId(() => [
                                _createVNode("i", {
                                  class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon",
                                  onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.currentPricing.businessClientId = null))
                                })
                              ]),
                              _: 1
                            }, 8, ["options", "modelValue"])
                          ]),
                          _createVNode("div", _hoisted_60, [
                            _createVNode("p", _hoisted_61, _toDisplayString(_ctx.$t('businessClient.business-client-type')), 1),
                            _createVNode(_component_Multiselect, {
                              label: "name",
                              valueProp: "id",
                              options: $setup.businessClientTypesTranslations,
                              modelValue: $setup.currentPricing.businessClientTypeId,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ($setup.currentPricing.businessClientTypeId = $event)),
                              searchable: true,
                              id: "currency-select",
                              canDeselect: true,
                              closeOnSelect: true,
                              class: "custom-multiselect-input currency"
                            }, {
                              caret: _withId(() => [
                                _hoisted_62
                              ]),
                              clear: _withId(() => [
                                _createVNode("i", {
                                  class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon",
                                  onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.currentPricing.businessClientTypeId = null))
                                })
                              ]),
                              _: 1
                            }, 8, ["options", "modelValue"])
                          ])
                        ]),
                        _createVNode("div", _hoisted_63, [
                          _createVNode("div", _hoisted_64, [
                            _createVNode("p", _hoisted_65, _toDisplayString(_ctx.$t('priceList.coupon')), 1),
                            _createVNode("div", _hoisted_66, [
                              _createVNode("div", _hoisted_67, [
                                _createVNode(_component_Multiselect, {
                                  label: "couponName",
                                  valueProp: "id",
                                  options: $setup.coupons,
                                  modelValue: $setup.currentPricing.couponId,
                                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ($setup.currentPricing.couponId = $event)),
                                  searchable: true,
                                  id: "currency-select",
                                  canDeselect: true,
                                  closeOnSelect: true,
                                  class: "custom-multiselect-input"
                                }, {
                                  caret: _withId(() => [
                                    _hoisted_68
                                  ]),
                                  _: 1
                                }, 8, ["options", "modelValue"])
                              ])
                            ])
                          ])
                        ]),
                        ($setup.currentPricing.couponId)
                          ? (_openBlock(), _createBlock("div", _hoisted_69, [
                              _createVNode("div", _hoisted_70, [
                                _createVNode("p", _hoisted_71, _toDisplayString(_ctx.$t('priceList.text-for-coupon')), 1),
                                _withDirectives(_createVNode("input", {
                                  type: "text",
                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ($setup.currentPricing.couponText = $event)),
                                  class: ["form-control h-auto bookit-input", 
                                                        $setup.validated && $setup.currentPricing.couponId && !$setup.currentPricing.couponText
                                                            ? 'incorrect-text'
                                                            : ''
                                                    ],
                                  maxlength: "255",
                                  onInput: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => ($setup.checkCouponTextLength && $setup.checkCouponTextLength(...args)))
                                }, null, 34), [
                                  [_vModelText, $setup.currentPricing.couponText]
                                ]),
                                _createVNode("span", _hoisted_72, [
                                  _createVNode("span", {
                                    class: { 'length-limit': ($setup.currentPricing.couponText?.length ?? 0) > 255 }
                                  }, _toDisplayString($setup.currentPricing.couponText?.length), 3),
                                  _hoisted_73
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        ($setup.currentPricing.couponId)
                          ? (_openBlock(), _createBlock("div", _hoisted_74, [
                              _createVNode("div", _hoisted_75, [
                                _createVNode("p", _hoisted_76, _toDisplayString(_ctx.$t('priceList.text-for-coupon-link')), 1),
                                _withDirectives(_createVNode("input", {
                                  type: "text",
                                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ($setup.currentPricing.couponLink = $event)),
                                  class: ["form-control h-auto bookit-input", 
                                                        $setup.validated && $setup.currentPricing.couponId && !$setup.currentPricing.couponLink
                                                            ? 'incorrect-text'
                                                            : ''
                                                    ],
                                  maxlength: "1000",
                                  onInput: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => ($setup.checkCouponLinkLength && $setup.checkCouponLinkLength(...args)))
                                }, null, 34), [
                                  [_vModelText, $setup.currentPricing.couponLink]
                                ]),
                                _createVNode("span", _hoisted_77, [
                                  _createVNode("span", {
                                    class: { 'length-limit': ($setup.currentPricing.couponLink?.length ?? 0) > 255 }
                                  }, _toDisplayString($setup.currentPricing.couponLink?.length), 3),
                                  _hoisted_78
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createVNode("div", _hoisted_79, [
                      _createVNode("form", {
                        onSubmit: _cache[33] || (_cache[33] = _withModifiers(($event: any) => ($setup.addMorePriceLine($event)), ["prevent"])),
                        novalidate: ""
                      }, [
                        _createVNode("div", _hoisted_80, [
                          _createVNode("div", _hoisted_81, [
                            _createVNode("div", _hoisted_82, [
                              ($setup.currentPricing.productPriceLines.length > 0)
                                ? (_openBlock(), _createBlock("div", _hoisted_83, [
                                    _createVNode("div", _hoisted_84, [
                                      ($setup.product.pricePerPerson && !$setup.isDesktopScreen)
                                        ? (_openBlock(), _createBlock("p", _hoisted_85, _toDisplayString(_ctx.$t('pricelist.label.customer')), 1))
                                        : ($setup.product.pricePerPerson && $setup.isDesktopScreen)
                                          ? (_openBlock(), _createBlock("p", _hoisted_86, _toDisplayString(_ctx.$t('customerType.customerType')), 1))
                                          : (_openBlock(), _createBlock("p", _hoisted_87, _toDisplayString(_ctx.$t('product.unitName')), 1))
                                    ]),
                                    _createVNode("div", _hoisted_88, _toDisplayString(_ctx.$t('priceList.QTY')), 1),
                                    _createVNode("div", _hoisted_89, _toDisplayString(_ctx.$t('priceList.qty-to-use')), 1),
                                    _createVNode("div", _hoisted_90, [
                                      ($setup.product.pricePerPerson)
                                        ? (_openBlock(), _createBlock("p", _hoisted_91, _toDisplayString(_ctx.$t('priceList.price')), 1))
                                        : (_openBlock(), _createBlock("p", _hoisted_92, _toDisplayString(_ctx.$t('product.unitPrice')), 1))
                                    ]),
                                    _createVNode("div", _hoisted_93, [
                                      _createVNode("p", _hoisted_94, _toDisplayString(_ctx.$t('priceList.bar-code')), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.currentPricing.productPriceLines, (pricing, index) => {
                                return (_openBlock(), _createBlock("div", {
                                  class: "row person-price-list",
                                  key: pricing.id
                                }, [
                                  (pricing.productCustomerType)
                                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                        _createVNode("div", _hoisted_95, [
                                          _withDirectives(_createVNode("input", {
                                            "onUpdate:modelValue": ($event: any) => (pricing.productCustomerType.name = $event),
                                            class: ["form-control h-auto bookit-input", 
                                                                        ($setup.tempValidation && !pricing.productCustomerType.name)
                                                                            ? 'incorrect-text'
                                                                            : ''
                                                                    ],
                                            type: "text",
                                            id: 'customer-select-' + index,
                                            autocomplete: "off",
                                            required: "",
                                            onChange: ($event: any) => (pricing.productCustomerType.id = '')
                                          }, null, 42, ["onUpdate:modelValue", "id", "onChange"]), [
                                            [_vModelText, pricing.productCustomerType.name]
                                          ]),
                                          ($setup.tempValidation && pricing.productCustomerType.name == '')
                                            ? (_openBlock(), _createBlock("p", _hoisted_96, [
                                                _hoisted_97,
                                                ($setup.product.pricePerPerson == true)
                                                  ? (_openBlock(), _createBlock("span", _hoisted_98, _toDisplayString(_ctx.$t('valid.productCustomerTypeIsRequired')), 1))
                                                  : (_openBlock(), _createBlock("span", _hoisted_99, _toDisplayString(_ctx.$t('valid.unitNameIsRequired')), 1))
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createVNode("div", _hoisted_100, [
                                          _withDirectives(_createVNode("input", {
                                            type: "number",
                                            placeholder: _ctx.$t('product.priceList.placeholder.customerQuantity'),
                                            onKeypress: _cache[22] || (_cache[22] = ($event: any) => ($setup.filterKey($event))),
                                            "onUpdate:modelValue": ($event: any) => (pricing.quantity = $event),
                                            class: "form-control h-auto bookit-input",
                                            onChange: ($event: any) => {
                                                                        if (pricing.quantity != 0 && !pricing.quantity)
                                                                            pricing.quantity = null;
                                                                    },
                                            onPaste: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.filterPastedOnlyNumber && _ctx.filterPastedOnlyNumber(...args)))
                                          }, null, 40, ["placeholder", "onUpdate:modelValue", "onChange"]), [
                                            [_vModelText, pricing.quantity]
                                          ])
                                        ]),
                                        _createVNode("div", _hoisted_101, [
                                          _withDirectives(_createVNode("input", {
                                            type: "number",
                                            onKeypress: _cache[24] || (_cache[24] = ($event: any) => ($setup.filterKey($event))),
                                            "onUpdate:modelValue": ($event: any) => (pricing.qtyToUse = $event),
                                            class: "form-control h-auto bookit-input",
                                            onPaste: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.filterPastedOnlyNumber && _ctx.filterPastedOnlyNumber(...args)))
                                          }, null, 40, ["onUpdate:modelValue"]), [
                                            [_vModelText, pricing.qtyToUse]
                                          ])
                                        ]),
                                        _createVNode("div", _hoisted_102, [
                                          _withDirectives(_createVNode("input", {
                                            min: "0",
                                            step: "0.01",
                                            "onUpdate:modelValue": ($event: any) => (pricing.amount = $event),
                                            class: ["form-control h-auto bookit-input", 
                                                                        $setup.tempValidation &&
                                                                        (pricing.amount == null ||
                                                                            pricing.amount < 0 ||
                                                                            pricing.amount.toString() === '')
                                                                            ? 'incorrect-text'
                                                                            : ''
                                                                    ],
                                            type: "text",
                                            required: "",
                                            onKeypress: _cache[26] || (_cache[26] = ($event: any) => (_ctx.filterKeyOnlyNumbersDot($event))),
                                            onPaste: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.filterPastedOnlyNumbersDotComma && _ctx.filterPastedOnlyNumbersDotComma(...args))),
                                            onChange: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => ($setup.clearTempValidation && $setup.clearTempValidation(...args))),
                                            onBlur: ($event: any) => ($setup.onBlurPriceAmount($event, pricing)),
                                            onFocus: ($event: any) => (pricing.amount = pricing.amount < 0 ? null : pricing.amount)
                                          }, null, 42, ["onUpdate:modelValue", "onBlur", "onFocus"]), [
                                            [_vModelText, pricing.amount]
                                          ]),
                                          (
                                                                        $setup.tempValidation &&
                                                                            (pricing.amount == null ||
                                                                                pricing.amount < 0 ||
                                                                                pricing.amount.toString() === '')
                                                                    )
                                            ? (_openBlock(), _createBlock("p", _hoisted_103, [
                                                _hoisted_104,
                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.priceAmountIsRequired')), 1)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createVNode("div", _hoisted_105, [
                                          _withDirectives(_createVNode("input", {
                                            min: "0",
                                            step: "1",
                                            "onUpdate:modelValue": ($event: any) => (pricing.barCode = $event),
                                            class: "form-control h-auto bookit-input",
                                            type: "text",
                                            onKeypress: _cache[29] || (_cache[29] = ($event: any) => (_ctx.filterKeyOnlyNumber($event))),
                                            onPaste: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.filterPastedOnlyNumber && _ctx.filterPastedOnlyNumber(...args))),
                                            onFocus: ($event: any) => (pricing.barCode = pricing.barCode < 0 ? null : pricing.barCode),
                                            maxlength: "30"
                                          }, null, 40, ["onUpdate:modelValue", "onFocus"]), [
                                            [
                                              _vModelText,
                                              pricing.barCode,
                                              void 0,
                                              { trim: true }
                                            ]
                                          ])
                                        ]),
                                        _createVNode("div", _hoisted_106, [
                                          _createVNode("span", {
                                            onClick: ($event: any) => ($setup.removeCustomerType(index)),
                                            class: "icon"
                                          }, [
                                            _hoisted_107
                                          ], 8, ["onClick"])
                                        ])
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ])
                          ]),
                          _createVNode("div", _hoisted_108, [
                            (
                                                        $setup.currentPricing &&
                                                            $setup.currentPricing.productPriceLines &&
                                                            $setup.currentPricing.productPriceLines.length === 0
                                                    )
                              ? (_openBlock(), _createBlock("div", _hoisted_109, [
                                  _createVNode("p", {
                                    id: "add-customer-text",
                                    style: {"text-align":"center"},
                                    class: ["product-title", 
                                                            $setup.validated && $setup.currentPricing.productPriceLines.length === 0
                                                                ? 'incorrect-text'
                                                                : ''
                                                        ]
                                  }, _toDisplayString(_ctx.$t('priceList.addAtLeastOneCustomerType')), 3)
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode("div", {
                              class: ["col-12 add-price-line", $setup.currentPricing.productPriceLines.length > 0 ? 'col-lg-6' : '']
                            }, [
                              _createVNode("button", _hoisted_110, [
                                _hoisted_111,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('priceList.addPriceLine')), 1)
                              ])
                            ], 2),
                            ($setup.currentPricing.productPriceLines.length > 0)
                              ? (_openBlock(), _createBlock("div", _hoisted_112, [
                                  _createVNode("div", {
                                    class: "btn browse-photo green-button set-price",
                                    style: {"display":"none"},
                                    "data-toggle": "modal",
                                    id: "setb2cPricebtn",
                                    "data-target": "#setb2cPrice",
                                    onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => ($setup.openModal && $setup.openModal(...args)))
                                  }, _toDisplayString(_ctx.$t('setPriceButton.for.b2c.title')), 1),
                                  _createVNode("div", {
                                    class: "btn browse-photo green-button set-price",
                                    id: "preSetb2cPricebtn",
                                    onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => ($setup.openModalAvailable && $setup.openModalAvailable(...args))),
                                    disabled: $setup.priceListDuplicated
                                  }, _toDisplayString(_ctx.$t('setPriceButton.for.b2c.title')), 9, ["disabled"])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ], 32)
                    ])
                  ]))
            ])
          ])
        ]),
        _createVNode("div", _hoisted_113, [
          _createVNode("div", _hoisted_114, [
            _createVNode("div", _hoisted_115, [
              _createVNode("div", _hoisted_116, [
                ($setup.setb2cPriceStep === 'one')
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _createVNode("h5", _hoisted_117, _toDisplayString(_ctx.$t('setB2cPrice.modal.title1')), 1),
                      _createVNode("p", null, _toDisplayString(_ctx.$t('setB2cPrice.modal.text1')), 1)
                    ], 64))
                  : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _createVNode("h5", _hoisted_118, _toDisplayString(_ctx.$t('setB2cPrice.modal.title2')), 1),
                      _createVNode("p", null, _toDisplayString(_ctx.$t('setB2cPrice.modal.text2')), 1)
                    ], 64)),
                _hoisted_119
              ]),
              _createVNode("div", _hoisted_120, [
                _createVNode("div", _hoisted_121, [
                  _createVNode("div", _hoisted_122, [
                    _createVNode("div", _hoisted_123, [
                      _createVNode("div", _hoisted_124, _toDisplayString(_ctx.$t('customerType.customerType')) + ":", 1),
                      _createVNode("div", _hoisted_125, _toDisplayString(_ctx.$t('priceList.price')) + ":", 1),
                      ($setup.setb2cPriceStep === 'one')
                        ? (_openBlock(), _createBlock("div", _hoisted_126, _toDisplayString(_ctx.$t('priceList.official')) + ":", 1))
                        : (_openBlock(), _createBlock("div", _hoisted_127, _toDisplayString(_ctx.$t('setB2cPrice.modal.priority')) + ":", 1))
                    ]),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.currentPricing.productPriceLines, (priceLine, index) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "row",
                        key: priceLine.productCustomerType.name,
                        style: {"margin-bottom":"25px"}
                      }, [
                        _createVNode("div", _hoisted_128, _toDisplayString(priceLine.productCustomerType.name), 1),
                        _createVNode("div", _hoisted_129, _toDisplayString(priceLine.amount), 1),
                        ($setup.setb2cPriceStep === 'one')
                          ? (_openBlock(), _createBlock("div", _hoisted_130, [
                              _createVNode("input", {
                                class: "inp-cbx2",
                                name: "official",
                                type: "radio",
                                style: {"display":"none"},
                                id: 'official-' + index,
                                checked: priceLine.isOfficial,
                                onChange: ($event: any) => ($setup.watchChanges(index))
                              }, null, 40, ["id", "checked", "onChange"]),
                              _createVNode("label", {
                                class: "cbx2",
                                for: 'official-' + index,
                                tabindex: "12"
                              }, [
                                _hoisted_131
                              ], 8, ["for"])
                            ]))
                          : (_openBlock(), _createBlock("div", _hoisted_132, [
                              _createVNode(_component_Multiselect, {
                                options: [1, 2, 3],
                                onInput: ($event: any) => ($setup.watchSelection($event, index)),
                                modelValue: priceLine.priority,
                                "onUpdate:modelValue": ($event: any) => (priceLine.priority = $event),
                                modelModifiers: { lazy: true },
                                canDeselect: false,
                                closeOnSelect: true,
                                class: 
                                                        ($setup.tempValidation && priceLine.priority) ||
                                                        $setup.priceListDuplicatedPriorities.includes(priceLine.priority)
                                                            ? 'incorrect-text'
                                                            : ''
                                                    
                              }, null, 8, ["onInput", "modelValue", "onUpdate:modelValue", "class"])
                            ]))
                      ]))
                    }), 128))
                  ]),
                  _createVNode("div", _hoisted_133, [
                    _createVNode("h5", _hoisted_134, _toDisplayString(_ctx.$t('documents.preview')) + ":", 1),
                    _createVNode("div", _hoisted_135, [
                      ($setup.setb2cPriceStep === 'one')
                        ? (_openBlock(), _createBlock("div", _hoisted_136, [
                            _hoisted_137
                          ]))
                        : _createCommentVNode("", true),
                      ($setup.setb2cPriceStep === 'one')
                        ? (_openBlock(), _createBlock("div", _hoisted_138, [
                            _createVNode("p", _hoisted_139, _toDisplayString($setup.product.name), 1),
                            ($setup.product.region)
                              ? (_openBlock(), _createBlock("p", _hoisted_140, _toDisplayString($setup.product.region.name), 1))
                              : _createCommentVNode("", true),
                            _createVNode("span", _hoisted_141, _toDisplayString(_ctx.$t('priceList.officialPrice')) + ":", 1),
                            _createVNode("span", _hoisted_142, _toDisplayString($setup.getOfficialPrice()), 1)
                          ]))
                        : (_openBlock(), _createBlock("div", _hoisted_143, [
                            _createVNode("h6", _hoisted_144, [
                              _hoisted_145,
                              _createTextVNode(" " + _toDisplayString($setup.product.name), 1)
                            ]),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.prioritizedLines(), (price, index) => {
                              return (_openBlock(), _createBlock("div", {
                                class: "row",
                                style: {"margin":"0"},
                                key: index
                              }, [
                                _createVNode("div", _hoisted_146, [
                                  _hoisted_147,
                                  _createTextVNode(" " + _toDisplayString(price.productCustomerType.name), 1)
                                ]),
                                _createVNode("div", _hoisted_148, [
                                  _createVNode("span", _hoisted_149, _toDisplayString(price.amount), 1),
                                  _createTextVNode(" " + _toDisplayString(price.currencySymbol), 1)
                                ])
                              ]))
                            }), 128))
                          ]))
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_150, [
                ($setup.setb2cPriceStep === 'one')
                  ? (_openBlock(), _createBlock("button", {
                      key: 0,
                      onClick: _cache[34] || (_cache[34] = ($event: any) => ($setup.setb2cPriceStep = 'two')),
                      type: "button",
                      class: "btn btn-secondary"
                    }, _toDisplayString(_ctx.$t('button.next')), 1))
                  : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _createVNode("button", {
                        onClick: _cache[35] || (_cache[35] = ($event: any) => ($setup.setb2cPriceStep = 'one')),
                        type: "button",
                        class: "btn btn-secondary"
                      }, _toDisplayString(_ctx.$t('button.back')), 1),
                      _createVNode("button", {
                        onClick: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => ($setup.submitUpdates && $setup.submitUpdates(...args))),
                        type: "button",
                        class: "btn btn-secondary"
                      }, _toDisplayString(_ctx.$t('button.save')), 1)
                    ], 64))
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_151, [
        _createVNode("div", _hoisted_152, [
          _createVNode("div", _hoisted_153, [
            _createVNode("button", {
              class: "order-modify-button-wrapper close-button-wrapper",
              onClick: _cache[37] || (_cache[37] = ($event: any) => ($setup.goBack())),
              type: "button"
            }, _toDisplayString(_ctx.$t('button.cancel')), 1)
          ]),
          _createVNode("div", _hoisted_154, [
            _createVNode("button", {
              class: "order-modify-button-wrapper edit-order",
              onClick: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => ($setup.mainSaveProductPrice && $setup.mainSaveProductPrice(...args))),
              type: "button"
            }, [
              _hoisted_155,
              _createVNode("p", null, _toDisplayString(_ctx.$t('button.save')), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
})